import type { ThemePack, ThemePalette } from '@dropstack/core';

const kebab = (s: string) => s.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

/** CSS variable name for a palette key: skyTop → --ds-sky-top */
export const paletteVar = (k: keyof ThemePalette) => `--ds-${kebab(k)}`;

/** Write the theme's palette as CSS variables (default: on <html>). */
export function applyThemeCssVars(theme: ThemePack, el: HTMLElement = document.documentElement): void {
  for (const [k, v] of Object.entries(theme.palette)) el.style.setProperty(paletteVar(k as keyof ThemePalette), v);
  el.dataset.theme = theme.id;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme.palette.skyTop);
}
